/**
 * 组织人员管理路由配置
 */
const userRoute = {
  path: 'user',
  name: 'orgUser',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'orgUserList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '组织人员管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default userRoute;
